module.exports = __webpack_public_path__ + "static/project-5-before-3b69754a01d69754689798c7d38ea79a.png";